import { createContext, ReactNode, useContext, useState } from 'react';
import { Tutorial } from 'types/tutorial';


import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

interface AppContextInterface {
    tutorial?: Tutorial;
    setTutorial: (val?: any) => void;
}

interface AppProviderProps {
    children: ReactNode;
}

const AppContext = createContext({} as AppContextInterface);

function AppContextData(): AppContextInterface {
    const [tutorial, setTutorial] = useState<Tutorial>();

    return {
        tutorial,
        setTutorial
    };
}

const AppContextProvider = ({ children }: AppProviderProps) => {
    const contextData: AppContextInterface = AppContextData();

    return <AppContext.Provider value={contextData}>{children}</AppContext.Provider>;
};

const useAppContext = (): AppContextInterface => {
    const context = useContext(AppContext);

    if (typeof context === 'undefined') {
        throw new Error('Error on appContext');
    }

    return context;
};

export { AppContextProvider, useAppContext };
